<div class="pb-2">
  <div class="k-form-field" [class.has-error]="showError">
    <span *ngIf="to.label && to.hideLabel !== true" [attr.for]="id">
      {{ to.label }}
      <span *ngIf="to.required && to.hideRequiredMarker !== true" class="k-required">*</span>
    </span>
    <ng-container *ngFor="let option of to.options; let i=index;">
      <span class="mt-2" style="display: flex;">
        <input type="checkbox" [id]="id + '_' + i" [value]="option.value" [class.k-state-invalid]="showError"
          [checked]="formControl.value && formControl.value[option.value]" [formlyAttributes]="field"
          (change)="onChange(option.value, $event.target.checked)" kendoCheckBox class="ml-4" />
        <label [class]="to.className + ' k-checkbox-label'" [for]="id + '_' + i">
          {{ option.label }}
        </label>
      </span>
    </ng-container>
    <small *ngIf="to.description" class="form-text text-muted ml-4">{{ to.description }}</small>
    <div *ngIf="showError && to.hideLabel !== true" class="k-field-info k-required ml-4" [style.top]="0">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  </div>
</div>